import { GET, POST, RBAC_API, SIGNUP_API } from '../constants';
import { jwtTokenHeader, request } from '../utils';

export const getContentPartnerGroups = async () =>
  request(
    GET,
    `${RBAC_API}/v1/content-partner-groups`,
    null,
    await jwtTokenHeader(),
    'Getting content partner groups failed.'
  ).catch((err) => {
    console.error('Getting content partner groups failed ' + err);
  });

/**
 * Pending signup (KOALA-1833) — public RBAC endpoints, proxied without JWT.
 * Same URL shape as RBAC: /v1/pending-signups
 */
export const createPendingSignup = async (contact) =>
  request(POST, `${RBAC_API}/v1/pending-signups`, contact, {}, 'Failed to create pending signup.', false);

export const verifyPendingSignup = async (token) =>
  request(
    GET,
    `${RBAC_API}/v1/pending-signups/verify/${encodeURIComponent(token)}`,
    null,
    {},
    'Failed to verify pending signup.',
    false
  );

/**
 * BFF wrappers (Phase 2) — Express forwards to RBAC and can add SES/Jira later.
 */
export const requestSignupVerification = async (contact) =>
  request(POST, `${SIGNUP_API}/request`, contact, {}, 'Failed to submit signup request.', false);

export const verifySignup = async (token) =>
  request(GET, `${SIGNUP_API}/verify/${encodeURIComponent(token)}`, null, {}, 'Failed to verify signup.', false);
